const getStorageKey = (role) => `${role}_loginState`;

export const getRoleFromPathname = () => {
  if (typeof window === "undefined" || !window.location?.pathname) return "admin";
  return window.location.pathname.includes("/student") ? "student" : "admin";
};

export const getToken = (role) => {
  const r = role ?? getRoleFromPathname();
  try {
    const raw = localStorage.getItem(getStorageKey(r));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.user?.token ?? null;
  } catch (error) {
    console.error("Error getting token:", error);
    return null;
  }
};

export const setToken = (token, role) => {
  const r = role ?? getRoleFromPathname();
  try {
    const raw = localStorage.getItem(getStorageKey(r));
    const data = raw ? JSON.parse(raw) : { user: {}, isLoggedIn: true };
    data.user = { ...data.user, token };
    localStorage.setItem(getStorageKey(r), JSON.stringify(data));
  } catch (error) {
    console.error("Error setting token:", error);
  }
};

export const removeToken = (role) => {
  const r = role ?? getRoleFromPathname();
  try {
    const raw = localStorage.getItem(getStorageKey(r));
    if (!raw) return;
    const data = JSON.parse(raw);
    if (data.user) {
      delete data.user.token;
      localStorage.setItem(getStorageKey(r), JSON.stringify(data));
    }
  } catch (error) {
    console.error("Error removing token:", error);
  }
};

export const hasToken = (role) => getToken(role) !== null;

export const decodeToken = (token) => {
  try {
    if (!token) return null;
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

export const isTokenExpired = (token) => {
  try {
    const decoded = decodeToken(token);
    if (!decoded || !decoded.exp) return true;
    return decoded.exp < Date.now() / 1000;
  } catch (error) {
    console.error("Error checking token expiration:", error);
    return true;
  }
};

export const getTokenExpiration = (token) => {
  try {
    const decoded = decodeToken(token);
    if (!decoded || !decoded.exp) return null;
    return new Date(decoded.exp * 1000);
  } catch (error) {
    console.error("Error getting token expiration:", error);
    return null;
  }
};
